/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * Gallery.
 * Wrapper around Flickity slideshow. 
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 * @link https://flickity.metafizzy.co/
 */

import Flickity from "flickity";
import fade from 'flickity-fade';

class Gallery {
	init(){
		console.log("Gallery.init()");

		var flkty = new Flickity( '#gallery', {
		  autoPlay: 1500,
		  pauseAutoPlayOnHover: false,
		  draggable: false,
		  freeScroll: false,
		  fade: true,
		  pageDots: false,
		  prevNextButtons: false,
		  wrapAround: true,
		  lazyLoad: true,
		  bgLazyLoad: true,
		  setGallerySize: false,
		});
	}
}

export default new Gallery();